module.exports = __webpack_public_path__ + "static/media/27.6adda0a3.jpg";